import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when the user clicks on the add option button',
  name: 'custom_field_add_option',
  params: [],
};

export default META;
